import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onFetchStockProducts, onSetSelectedStockProduct, onSetTotalRows, selectStockProductState, setAction } from "../redux/slices/stockProductsSlice"
import { StockProductsAPI } from "../apis/StockProductsAPI"
import { StockProducts } from "../types/slices/StockProductsType"

export const useStockProductStore = () => {

    const dispatch = useDispatch()
    const { stockproducts, stockproductSelected, status, action, totalRows } = useSelector(selectStockProductState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getProductAvailability = async (data) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await StockProductsAPI.getProductAvailability(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(onSetTotalRows(response.data.total))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getStockProducts = async (data?: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await StockProductsAPI.get(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail, total } = response.data
            dispatch(onFetchStockProducts(detail || []))
            dispatch(onSetTotalRows(total))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createStock = async (data: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await StockProductsAPI.create(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createAdjustment = async (data: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await StockProductsAPI.adjustment(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedStockProduct = (branchoffice: StockProducts) => {
        try {
            dispatch(onSetSelectedStockProduct(branchoffice))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionStockProduct = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        stockproducts,
        stockproductSelected,
        status,
        action,
        totalRows,
        //actions
        getProductAvailability,
        setSelectedStockProduct,
        setActionStockProduct,
        getStockProducts,
        createStock,
        createAdjustment
    }
}